import React, { useState } from 'react';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import {
  Container,
  Box,
  Typography,
  useTheme,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TableRow,
  Paper,
  styled,
  Button,
  Modal,
  
  Pagination,
  Stack,
  IconButton,
} from '@mui/material';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import ChevronLeft from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRight from '@mui/icons-material/KeyboardDoubleArrowRight';
import CloseIcon from '@mui/icons-material/Close';
import MuiAlert from '@mui/material/Alert';
const CustomTableScrollbar = styled('div')(({ theme }) => ({
  '&::-webkit-scrollbar': {
    height: '6px',
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
  },
  scrollbarWidth: 'thin',
  scrollbarColor: `${theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.2)' : 'rgba(0,0,0,0.2)'} transparent`,
}));

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const SMSHistory = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [showUserGuideModal, setShowUserGuideModal] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  // Static data for SMS history
  const [smsHistory, setSmsHistory] = useState([
    {
      id: 1,
      message: 'Welcome to our institute!',
      sendTo: 'John Doe',
      date: '2025-08-28',
    },
    {
      id: 2,
      message: 'Your admission is confirmed.',
      sendTo: 'Jane Smith',
      date: '2025-08-27',
    },
    {
      id: 3,
      message: 'Reminder: Your payment is due.',
      sendTo: 'Alice Johnson',
      date: '2025-08-26',
    },
    {
      id: 4,
      message: 'Class schedule updated.',
      sendTo: 'Bob Brown',
      date: '2025-08-25',
    },
    {
      id: 5,
      message: 'New course available!',
      sendTo: 'Charlie Davis',
      date: '2025-08-24',
    },
    {
      id: 6,
      message: 'Your certificate is ready.',
      sendTo: 'David Wilson',
      date: '2025-08-23',
    },
    {
      id: 7,
      message: 'Important notice: Holiday tomorrow.',
      sendTo: 'Eve Adams',
      date: '2025-08-22',
    },
  ]);

  // Summary data
  const totalSMS = smsHistory.length;
  const messageSent = smsHistory.length - 1; // Assuming 1 failed message
  const messageFailed = 1;
  const remainingSMS = 1000 - totalSMS; // Assuming a total limit of 1000 SMS

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  const paginatedSMSHistory = smsHistory.slice(
    (page - 1) * rowsPerPage,
    page * rowsPerPage
  );

  return (
    <Container sx={{ maxWidth: '100%', boxSizing: 'border-box' }}>
            <Button
        startIcon={<ArrowBackIcon />}
        onClick={() => navigate('/dashboard')}
        sx={{
          mb: 2,
          textTransform: 'none',
          fontWeight: 600,
        }}
      >
        Back
      </Button>
      {/* Summary Section */}
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1, p: 2, boxShadow: 'none', maxWidth: '100%', boxSizing: 'border-box' }}>
        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
          SMS History
        </Typography>
        {/* <Box sx={{ display: 'flex', gap: 3 }}> */}
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            Total SMS: <span style={{ color: theme.palette.primary.main }}>{totalSMS}</span>
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            Message Sent: <span style={{ color: theme.palette.success.main }}>{messageSent}</span>
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            Message Failed: <span style={{ color: theme.palette.error.main }}>{messageFailed}</span>
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 'bold' }}>
            Remaining SMS: <span style={{ color: theme.palette.warning.main }}>{remainingSMS}</span>
          </Typography>
        </Box>
         <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <IconButton
                    onClick={() => setShowUserGuideModal(true)}
                    sx={{
                      width: 60,
                      height: 60,
                      borderRadius: '50%',
                      minWidth: 0, // Remove MUI's default padding
                    }}
                  >
                    <InfoOutlineIcon sx={{ fontSize: 30 }} />
                  </IconButton>
                </Box>
      </Box>

      {/* Table Section */}
      <Paper elevation={3} sx={{ paddingBottom: 0, maxWidth: '100%', boxSizing: 'border-box', mx: 'auto', backgroundColor: theme.palette.background.paper, borderRadius: '16px' }}>
        <Box sx={{ width: '100%', overflowX: 'auto' }}>
          <TableContainer sx={{ width: '100%', borderRadius: '16px' }}>
            <Table
              sx={{
                '& .MuiTableHead-root .MuiTableCell-root': {
                  fontWeight: 'bold',
                  backgroundColor: theme.palette.primary.main,
                  color: 'white'
                },
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>S.No</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Message</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Send To</TableCell>
                  <TableCell sx={{ fontWeight: 'bold', fontSize: '1.1rem' }}>Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {paginatedSMSHistory.map((sms, index) => (
                  <TableRow
                    key={sms.id}
                    sx={{
                      backgroundColor: index % 2 === 0 ? theme.palette.background.paper : theme.palette.background.paper,
                      '&:hover': {
                        backgroundColor: 'rgba(0, 0, 0, 0.04)',
                      },
                    }}
                  >
                    <TableCell sx={{ fontSize: '1rem' }}>{(page - 1) * rowsPerPage + index + 1}</TableCell>
                    <TableCell sx={{ fontSize: '1rem' }}>{sms.message}</TableCell>
                    <TableCell sx={{ fontSize: '1rem' }}>{sms.sendTo}</TableCell>
                    <TableCell sx={{ fontSize: '1rem' }}>{sms.date}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </Paper>

      {/* Pagination */}
      <Box
        sx={{
          maxWidth: '100%',
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mt: 1,
          p: 2,
          mx: 'auto',
          pt: 2,
        }}
      >
        <Typography
          variant="body2"
          color={theme.palette.primary.main}
        >
          Page <strong>{page}</strong> of <strong>{Math.ceil(smsHistory.length / rowsPerPage)}</strong>
        </Typography>
        <Stack direction="row" alignItems="center" spacing={1}>
          <IconButton
            onClick={() => handleChangePage(null, page - 1)}
            disabled={page === 1}
            sx={{
              color: theme.palette.primary.main,
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
              },
              '&.Mui-disabled': {
                opacity: 0.3,
              },
              borderRadius: '50%',
              width: '36px',
              height: '36px',
            }}
          >
            <ChevronLeft />
          </IconButton>
          {[...Array(Math.ceil(smsHistory.length / rowsPerPage))].map((_, index) => (
            <IconButton
              key={index + 1}
              onClick={() => handleChangePage(null, index + 1)}
              sx={{
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                backgroundColor: page === index + 1 ? theme.palette.primary.main : 'transparent',
                color: page === index + 1 ? theme.palette.primary.contrastText : theme.palette.text.primary,
                '&:hover': {
                  backgroundColor: page === index + 1 ? theme.palette.primary.dark : theme.palette.action.hover,
                },
              }}
            >
              {index + 1}
            </IconButton>
          ))}
          <IconButton
            onClick={() => handleChangePage(null, page + 1)}
            disabled={page >= Math.ceil(smsHistory.length / rowsPerPage)}
            sx={{
              color: theme.palette.primary.main,
              '&:hover': {
                backgroundColor: theme.palette.action.hover,
              },
              '&.Mui-disabled': {
                opacity: 0.3,
              },
              borderRadius: '50%',
              width: '36px',
              height: '36px',
            }}
          >
            <ChevronRight />
          </IconButton>
          <FormControl size="small" sx={{ minWidth: 100, ml: 1 }}>
            <InputLabel id="rows-per-page-label" sx={{ color: theme.palette.text.primary }}>Rows</InputLabel>
            <Select
              labelId="rows-per-page-label"
              value={rowsPerPage}
              onChange={(e) => {
                const newRowsPerPage = Number(e.target.value);
                setRowsPerPage(newRowsPerPage);
                handleChangePage(null, 1);
              }}
              label="Rows"
              sx={{
                height: '36px',
                color: theme.palette.text.primary,
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.text.primary,
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: theme.palette.primary.main,
                },
              }}
            >
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={10}>10</MenuItem>
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={30}>30</MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </Box>
       <Modal
      open={showUserGuideModal}
      onClose={() => setShowUserGuideModal(false)}
      BackdropProps={{ style: { backgroundColor: 'rgba(0, 0, 0, 0.8)' } }}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 800,
          bgcolor: 'background.paper',
          borderRadius: '16px',
          boxShadow: 24,
          overflow: 'hidden',
        }}
      >
        {/* Header */}
        <Box
          sx={{
            backgroundColor: theme.palette.primary.main,
            padding: '12px 16px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <Typography variant="h4" sx={{ color: '#fff', fontWeight: 'bold' }}>
            SMS History - User Guide
          </Typography>
          <IconButton
            onClick={() => setShowUserGuideModal(false)}
            sx={{ color: '#fff', position: 'absolute', right: 14 }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        {/* Scrollable Content */}
        <CustomTableScrollbar sx={{ maxHeight: '70vh', overflowY: 'auto', padding: '20px' }}>
          {/* Section 1: View SMS History */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mb: 1 }}
          >
            ➤ Follow these steps to view SMS history:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'pointer',
            }}
          >
            <li>
              The table displays the SMS history, including the <strong>S.No</strong>, <strong>Message</strong>, <strong>Send To</strong>, and <strong>Date</strong> for each message.
            </li>
            <li>
              Review the summary section above the table to see <strong>Total SMS</strong>, <strong>Message Sent</strong>, <strong>Message Failed</strong>, and <strong>Remaining SMS</strong>.
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The SMS history table is read-only and displays sent messages with their details.
          </Typography>

          {/* Section 2: Pagination */}
          <Typography
            variant="body1"
            sx={{ fontWeight: 'bold', color: theme.palette.primary.main, mt: 3, mb: 1 }}
          >
            ➤ Follow these steps to navigate the SMS history list:
          </Typography>
          <ul
            style={{
              marginLeft: '20px',
              lineHeight: '1.8',
              cursor: 'pointer',
            }}
          >
            <li>
              Use the pagination controls at the bottom to navigate through pages of SMS history records.
            </li>
            <li>
              Click the left (<strong>&lt;</strong>) or right (<strong>&gt;</strong>) arrows to move between pages.
            </li>
            <li>
              Select a specific page number by clicking on it.
            </li>
            <li>
              Adjust the number of rows per page using the dropdown menu (e.g., 5, 10, 20, 30 rows).
            </li>
          </ul>
          <Typography variant="body2" sx={{ mt: 2, color: theme.palette.text.primary }}>
            ⚠️ Note: The table displays only the selected number of rows per page.
          </Typography>

          {/* Bottom Close Button */}
          <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
            {/* <Button
              variant="contained"
              onClick={() => setShowUserGuideModal(false)}
              sx={{
                backgroundColor: theme.palette.primary.main,
                '&:hover': { backgroundColor: theme.palette.primary.dark },
                fontWeight: 'bold',
                padding: '8px 24px',
                borderRadius: '8px',
              }}
            >
              Close
            </Button> */}
          </Box>
        </CustomTableScrollbar>
      </Box>
    </Modal>
    </Container>
  );
};

export default SMSHistory;
